(function ($) {
   $(".hide-slider-element").each(function(index){
      $(this).remove();
    });
   
   $('.header-image-section-slider').slick({ 
      infinite: true,
      fade: true,
      arrows: false,
      dots: true,
      dotsClass: "custom-hero-dots slick-dots ",
      // verticalSwiping: true,
      autoplay: true,
      autoplaySpeed: 3000,
    });
  
})(jQuery);